export default __webpack_public_path__ + "assets/carousel-keycard-access.5edf4b7583b9b7815de8e482ad34cd74.webp";